import ViberRedirect from '@/pages/redirect/viber';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(redirect)/viber/')({
  component: ViberRedirect,
});
